import { Component, OnInit, OnDestroy, ViewChild, Renderer2, ElementRef, AfterViewInit } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { NgbDate, NgbDateParserFormatter, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SharedContainer } from '../../../shared/shared.container';
import { Angulartics2 } from 'angulartics2';
import { environment } from '../../../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SearchEngineService } from '../../../core/services/search-engine.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Sandbox } from '../../../core/facade/sandbox';
import { Store } from '@ngrx/store';
import { AuthState } from '../../../core/store/auth/auth.reducer';
import { GeneralState } from '../../../core/store/general/state';
import { AuthService as BasicAuth } from '../../../core/services/auth.service';
import { SocialAuthService } from 'angularx-social-login';
import { Subject } from 'rxjs';
import { IUser } from '../../../core/models/user.model';
import Swal from 'sweetalert2';
import { LabelType, Options } from '@angular-slider/ngx-slider';


declare const fbq: any;
declare const gtag: any;

@Component({
    selector: 'app-newsearch',
    templateUrl: './newsearch.html',
    styleUrls: ['./newsearch.scss'],
    styles: [`
    .custom-day {
      text-align: center;
      padding: 0.285rem 0.35rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
      outline: 0;
    }
    .custom-day:hover {
      background-color: #48a5db;
    }
    .custom-day.focused {
      background-color: #48a5db;
    }
    .custom-day.disabled {
      color: #BCC4F3;
    }
    .custom-day.range, .custom-day:hover {
    }

    .custom-day {
      text-align: center;
      padding: 0.185rem 0.25rem;
      display: inline-block;
      height: 2rem;
      width: 2rem;
    }
    .custom-day.focused {
      background-color: #e6e6e6;
    }
    .custom-day.range, .custom-day:hover {
      background-color: rgb(2, 117, 216);
      color: white;
    }
    .custom-day.faded {
      background-color: rgba(2, 117, 216, 0.5);
    }
  `]
})

export class NewSearchComponent extends Sandbox implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild('datepicker', { static: false }) datepicker;
    @ViewChild('myRangeInput', { static: false }) myRangeInput: ElementRef;

    deviceType: any;

    alive: boolean;
    result: string;
    currentPage = 0;

    fromDate: NgbDate;
    toDate: NgbDate;
    hoveredDate: NgbDate;

    checkInString: any = 'Check in';
    checkOutString: any = 'Check out';
    datesSelected: Boolean = false;
    noDatesSelected: Boolean = false;

    datesTracked: Boolean = false;
    experiencesTracked: Boolean = false;
    personalRequestTracked: Boolean = false;

    // initialization for calendars
    day: Number;
    month: Number;
    year: Number;
    minDate: any;
    startDateFrom: any;
    startDateTo: any;
    checkInStartValue: String;
    checkInEndValue: any;
    toShowRoomOptions: Boolean = false;
    nights: number;

    requestForSearch: any;
    requestButtonDisabled: Boolean = false;

    allRoomOptions = [
        { id: 1, number: 1 },
        { id: 2, number: 2 },
        { id: 3, number: 3 },
        { id: 4, number: 4 },
        { id: 5, number: 5 },
        { id: 6, number: 6 },
        { id: 7, number: 7 },
        { id: 8, number: 8 },
        { id: 9, number: 9 },
        { id: 10, number: 10 }
    ];
    allRoomOptionsModal = [
        { id: 0, number: 0 },
        { id: 1, number: 1 },
        { id: 2, number: 2 },
        { id: 3, number: 3 },
        { id: 4, number: 4 },
        { id: 5, number: 5 },
        { id: 6, number: 6 },
        { id: 7, number: 7 },
        { id: 8, number: 8 },
        { id: 9, number: 9 },
        { id: 10, number: 10 }
    ];
    roomModalRooms: string;
    roomModalAdults: number;
    roomModalChildren: number;
    whoSelection: string;
    adultsSelection: string;
    adultsSelection2: string;
    adultsSelection3: string;
    adultsSelection4: string;
    adultsSelection5: string;
    adultsSelection6: string;
    adultsSelection7: string;
    adultsSelection8: string;
    adultsSelection9: string;
    adultsSelection10: string;
    childrenSelection: string;
    childrenSelection2: string;
    childrenSelection3: string;
    childrenSelection4: string;
    childrenSelection5: string;
    childrenSelection6: string;
    childrenSelection7: string;
    childrenSelection8: string;
    childrenSelection9: string;
    childrenSelection10: string;

    _htmlForWhoModal: string;
    _finalHtmlForWhoModal: SafeHtml;

    // initialization for textarea
    personalRequestText: String;
    personalRequestRemainChars: any = 800;
    personalRequestMaxLength: any = 800;

    currentSelectedExp = 0;
    selectedExperiences: any;

    // initialization for experiences
    experiencesMappingRest = [
        { id: 7, name: 'Love to explore the local cuisine', checked: false, position: 1 },
        { id: 35, name: 'Looking for pet-friendly accommondation', checked: false, position: 2 },
        { id: 19, name: 'Looking to rent a car', checked: false, position: 3 },
        { id: 33, name: 'Concerned about COVID-19 safety protocols', checked: false, position: 4 },
        { id: 14, name: 'Celebrating our time together', checked: false, position: 5 },
        { id: 10, name: 'From massage to beauty services, you name it', checked: false, position: 6 },
        { id: 15, name: 'Wanting a workspace, got some work to do', checked: false, position: 7 },
        { id: 4, name: 'Want to spend precious time with my family', checked: false, position: 8 },
        { id: 12, name: 'Would love for child care or nanny services', checked: false, position: 9 },
        { id: 34, name: 'Looking for a place to host a venue', checked: false, position: 10 },
        { id: 20, name: 'Would love to be transfered from and to the airport', checked: false, position: 11 },
        { id: 6, name: 'Looking for high-end luxurious experiences', checked: false, position: 12 },
        { id: 13, name: 'Host our guests and/or our wedding party', checked: false, position: 13 },
        { id: 8, name: 'Want to experience the local way of life', checked: false, position: 14 },
        { id: 24, name: 'Want to explore the landmarks, sites and local history ', checked: false, position: 15 },
        { id: 5, name: 'On a budget trying to save money', checked: false, position: 16 },
        { id: 2, name: 'I want to enjoy the warm sun and the golden beaches', checked: false, position: 17 },
        { id: 3, name: 'My ideal scenario is to just lay back and relax', checked: false, position: 18 }
    ];

    selectedLocation = 'Crete';

    locations = [
        { value: 'Crete', backValue: null },
        { value: 'West Crete', backValue: 'West Crete' },
        { value: 'East Crete', backValue: 'East Crete' }
    ];

    public isLoggedIn$;
    public userId;
    userSignup = { email: null, name: null, surname: null, passwd: null };

    accommodationType: Number = -1;
    VillaSelected: Boolean = false;
    ApartmentSelected: Boolean = false;
    chosenLocations: Array<String>;
    value = 100;
    options: Options = {
        minLimit: 100,
        maxLimit: 10000,
        floor: 100,
        ceil: 5000,
        step: 50,
        hideLimitLabels: true,
        translate: (value: number, label: LabelType): string => {
            console.log(value);
            switch (value) {
                case 100:
                    return 'No limit';
                default:
                    return '<b>Max price:</b> €' + value;
            }
        }
    };


    constructor(public formatter: NgbDateParserFormatter, private renderer: Renderer2, private calendar: NgbCalendar,
        private domSanitizer: DomSanitizer, protected router: Router, private sharedContainer: SharedContainer,
        private spinner: NgxSpinnerService, protected appState$: Store<AuthState>, public generalState$: Store<GeneralState>,
        private basicAuth: BasicAuth, private auth: SocialAuthService,
        private angulartics2: Angulartics2, private deviceInfo: DeviceDetectorService, private searchService: SearchEngineService) {
        super(appState$, generalState$, basicAuth, router, auth);
        if (this.deviceInfo.isDesktop()) {
            this.deviceType = 'desktop';
        } else if (this.deviceInfo.isMobile()) {
            this.deviceType = 'mobile';
            setTimeout(() => {
                this.handleSlide();
                const dot = <HTMLElement>document.getElementById('page' + this.currentPage);
                dot.classList.remove('hidden');
            }, 500);
        } else if (this.deviceInfo.isTablet()) {
            this.deviceType = 'tablet';
        }
        const current = new Date();
        this.minDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };

        this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 1);

        this.setCalendars();

    }

    public userLoggedInSub = new Subject<boolean>();
    public userLoggedIn$ = this.userLoggedInSub.asObservable();

    ngOnInit() {
        // analytics START
        if (environment.production) {
            fbq('track', 'PageView', {});
        }
        // analytics END
        this.alive = true;
        this.chosenLocations = new Array<String>();

        this.whoSelection = this.allRoomOptions[0].number.toString();
        this.adultsSelection = this.allRoomOptions[1].number.toString();
        this.adultsSelection2 = this.allRoomOptions[1].number.toString();
        this.adultsSelection3 = this.allRoomOptions[1].number.toString();
        this.adultsSelection4 = this.allRoomOptions[1].number.toString();
        this.adultsSelection5 = this.allRoomOptions[1].number.toString();
        this.adultsSelection6 = this.allRoomOptions[1].number.toString();
        this.adultsSelection7 = this.allRoomOptions[1].number.toString();
        this.adultsSelection8 = this.allRoomOptions[1].number.toString();
        this.adultsSelection9 = this.allRoomOptions[1].number.toString();
        this.adultsSelection10 = this.allRoomOptions[1].number.toString();
        this.childrenSelection = '0';
        this.childrenSelection2 = '0';
        this.childrenSelection3 = '0';
        this.childrenSelection4 = '0';
        this.childrenSelection5 = '0';
        this.childrenSelection6 = '0';
        this.childrenSelection7 = '0';
        this.childrenSelection8 = '0';
        this.childrenSelection9 = '0';
        this.childrenSelection10 = '0';

        this._finalHtmlForWhoModal = this.domSanitizer.bypassSecurityTrustHtml(
            '<div class="roomOptContainer">'
            + '<div style="display: inline-block;" class="roomNumberOpt"><p>Room 1</p></div>'
            + '<div style="display: inline-block;margin-top:10px;"'
            + 'class="roomAdultsInput"><p>&nbspAdults:&nbsp</p></div><input'
            + ' style="width:40px;background-color:#48c3df;text-align:center;"'
            + 'class="adultsInput" type="number"'
            + 'min="1" id="adultsForRoom onKeyDown="return false" max="10" value="2" />'
            + '<div style="display:inline-block;" class="roomChildrenOpt"><p>Children:&nbsp</p></div>'
            + '<input style="width:40px;background-color:#48c3df;text-align:center;"'
            + 'class="childrenInput" type="number" min="0"'
            + ' id="childrensForRoom onKeyDown="return false" max="10" value="0" /></div>'
        );

        this.roomModalRooms = '1';
        this.roomModalAdults = 2;
        this.roomModalChildren = 0;

        this.selectedExperiences = new Array();

        this.nights = 1;

    }

    ngAfterViewInit() {
        const dot = <HTMLElement>document.getElementById('page' + this.currentPage);
        if (dot !== null) {
            dot.classList.remove('hidden');
        }
    }

    ngOnDestroy() {
        this.alive = false;
        this.currentPage = 0;
    }

    addExpToList(expId: string, isChecked: boolean, position: number) {

        if (!this.experiencesTracked) {
            this.angulartics2.eventTrack.next({ action: 'ExperiencesAdded' });
            this.experiencesTracked = true;
        }

        const element = <HTMLElement>document.getElementById(expId);

        if (isChecked) {
            this.experiencesMappingRest[position - 1].checked = false;
            const index = this.selectedExperiences.indexOf(expId, 0);
            if (index > -1) {
                this.selectedExperiences.splice(index, 1);
                element.classList.remove('expChoiceFocused');
                --this.currentSelectedExp;
            }
        } else {
            if (this.currentSelectedExp === 3) { return; }
            this.experiencesMappingRest[position - 1].checked = true;
            this.selectedExperiences.push(expId);
            element.classList.add('expChoiceFocused');
            ++this.currentSelectedExp;
        }

    }

    manageScreen4Scroll() {
        const sliderSlide = <HTMLElement>document.getElementById('screen4');
        if (sliderSlide.classList.contains('extraHeight')) {
            sliderSlide.classList.remove('extraHeight');
            sliderSlide.classList.add('lessHeight');
        } else {
            sliderSlide.classList.add('extraHeight');
            sliderSlide.classList.remove('lessHeight');
        }
    }

    removeHeight() {
        this.submitRoomsModal();
        const sliderSlide = <HTMLElement>document.getElementById('screen4');
        if (sliderSlide.classList.contains('extraHeight')) {
            sliderSlide.classList.remove('extraHeight');
            sliderSlide.classList.add('lessHeight');
            window.scroll(0, 0);
        }
        window.scroll(0, 0);
    }

    openRoomsModal() {
        if (!this.toShowRoomOptions) {
            this.toShowRoomOptions = true;
            const allDots = <HTMLElement>document.getElementById('sliderr__dotsAll');
            allDots.classList.add('hidden');
            this.manageScreen4Scroll();
        } else {
            this.submitRoomsModal();
        }
    }

    closeRoomModal() {
        this.toShowRoomOptions = false;
        const allDots = <HTMLElement>document.getElementById('sliderr__dotsAll');
        allDots.classList.remove('hidden');
    }

    submitRoomsModal() {
        this.roomModalRooms = '1';
        this.roomModalAdults = 0;
        this.roomModalChildren = 0;

        // get rooms
        this.roomModalRooms = this.whoSelection;
        this.roomModalAdults += parseInt(this.adultsSelection, 10);
        this.roomModalChildren += parseInt(this.childrenSelection, 10);
        for (let i = 2; i <= parseInt(this.roomModalRooms, 10); i++) {
            this.roomModalAdults += parseInt(this['adultsSelection' + i], 10);
            this.roomModalChildren += parseInt(this['childrenSelection' + i], 10);
        }
        this.toShowRoomOptions = false;

        this.angulartics2.eventTrack.next({ action: 'PeopleTravellingSubmittedMobile' });

    }

    updateWhoModal() {
        this.roomModalRooms = '1';
        this.roomModalAdults = 0;
        this.roomModalChildren = 0;

        // get rooms
        this.roomModalRooms = this.whoSelection;
        this.roomModalAdults += parseInt(this.adultsSelection, 10);
        this.roomModalChildren += parseInt(this.childrenSelection, 10);
        for (let i = 2; i <= parseInt(this.roomModalRooms, 10); i++) {
            this.roomModalAdults += parseInt(this['adultsSelection' + i], 10);
            this.roomModalChildren += parseInt(this['childrenSelection' + i], 10);
        }
    }

    handleSlide() {

        // let dots          = 6;
        const sliderElem = document.querySelector('.sliderr');
        const dotElems = sliderElem.querySelectorAll('.sliderr__dot');
        const indicatorElem = sliderElem.querySelector('.sliderr__indicator');

        Array.prototype.forEach.call(dotElems, (dotElem) => {

            dotElem.addEventListener('click', () => {

                const currentPos = parseInt(sliderElem.getAttribute('data-pos'), 10);
                const newPos = parseInt(dotElem.getAttribute('data-pos'), 10);

                const newDirection = (newPos > currentPos ? 'right' : 'left');
                const currentDirection = (newPos < currentPos ? 'right' : 'left');

                indicatorElem.classList.remove(`sliderr__indicator--${currentDirection}`);
                indicatorElem.classList.add(`sliderr__indicator--${newDirection}`);
                sliderElem.setAttribute('data-pos', newPos.toString());

                this.currentPage = newPos;

            });

        });

    }

    roomSelected() {
        this._htmlForWhoModal = '';
        const selectedRooms = parseInt(this.whoSelection, 10);
        for (let i = 1; i <= selectedRooms; i++) {
            this._htmlForWhoModal += '<div class="roomOptContainer">'
                + '<div style="display:inline-block" class="roomNumberOpt"><p>Room ' + i + '</p></div>'
                + '<div style="display: inline-block;margin-top:10px;"'
                + 'class="roomAdultsInput"><p>&nbspAdults:&nbsp</p></div><input '
                + 'style="width:40px;background-color:#48c3df;text-align:center;"'
                + 'class="adultsInput" type="number"'
                + 'min="1" max="10" id="adultsForRoom' + i + '" value="2" />'
                + '<div style="display:inline-block" class="roomChildrenOpt">'
                + '<p>Children:&nbsp</p></div><input style="width:40px;background-color:#48c3df;text-align:center;"'
                + 'class="childrenInput" type="number" min="0"'
                + ' id="childrensForRoom' + i + '" value="0" max="10" /></div>';
        }
        this._finalHtmlForWhoModal = this.domSanitizer.bypassSecurityTrustHtml(this._htmlForWhoModal);


        for (let j = 2; j <= 10; j++) {
            const elemTmp = <HTMLElement>document.getElementById('roomOptContainer' + j);
            elemTmp.classList.add('hidden');
        }
        for (let i = 2; i <= selectedRooms; i++) {
            const elem = <HTMLElement>document.getElementById('roomOptContainer' + i);
            elem.classList.remove('hidden');
        }

        this.updateWhoModal();
    }

    nextSlide(gesture) {

        if (this.chosenLocations.length === 0) {
            const elem = <HTMLElement>document.getElementById('required-where');
            elem.classList.add('required-info');
            return;
        }
        if (this.accommodationType === -1) {
            const elem = <HTMLElement>document.getElementById('required-accomtype');
            elem.classList.add('required-info');
            return;
        }
        if (!this.datesSelected && this.currentPage === 1 && gesture === 'left') {
            const elem = <HTMLElement>document.getElementById('required-when');
            elem.classList.add('required-info');
            this.noDatesSelected = true;
            return;
        }

        if (this.currentPage >= 0 && gesture === 'left') {
            const line = <HTMLDivElement>document.getElementById('line-' + (this.currentPage + 1));
            line.classList.add('line-bgc');
        } else if (this.currentPage >= 0 && gesture === 'right') {
            const line = <HTMLDivElement>document.getElementById('line-' + this.currentPage);
            line.classList.remove('line-bgc');
        }

        const page0 = <HTMLElement>document.getElementById('page0');
        const page1 = <HTMLElement>document.getElementById('page1');
        const page2 = <HTMLElement>document.getElementById('page2');

        if (gesture === 'left' && this.currentPage <= 1) {
            if (this.currentPage === 0) {
                page0.classList.add('hidden');
                page1.classList.remove('hidden');
            } else if (this.currentPage === 1) {
                page1.classList.add('hidden');
                page2.classList.remove('hidden');
            }
            const dot = <HTMLElement>document.getElementById('page' + ++this.currentPage);
            dot.click();
        } else if (gesture === 'right' && this.currentPage > 0) {
            if (gesture === 'right' && this.currentPage >= 0) {
                if (this.currentPage === 2) {
                    page2.classList.add('hidden');
                    page1.classList.remove('hidden');
                } else if (this.currentPage === 1) {
                    page1.classList.add('hidden');
                    page0.classList.remove('hidden');
                }
                const dot = <HTMLElement>document.getElementById('page' + --this.currentPage);
                dot.click();
            }
        }

    }

    addLocation(location: string) {
        const selectedLocation = <HTMLElement>document.getElementById(location);
        const selectedLocationLabel = <HTMLElement>document.getElementById(location + 'Lbl');
        if (!selectedLocation.classList.contains('addLoc')) {
            selectedLocation.classList.add('addLoc');
            selectedLocationLabel.classList.add('addLocLbl');
            this.chosenLocations.push(location);
        } else {
            selectedLocation.classList.remove('addLoc');
            selectedLocationLabel.classList.remove('addLocLbl');
            const index = this.chosenLocations.indexOf(location);
            if (index > -1) {
                this.chosenLocations.splice(index, 1);
            }
        }
        // add required tag
        const required = <HTMLElement>document.getElementById('required-where');
        if (this.chosenLocations.length > 0 && required.classList.contains('required-info')) {
            required.classList.remove('required-info');
        }
    }

    chooseAccomType(type: number) {
        const element1 = <HTMLDivElement>document.getElementById('villaOpt');
        const element2 = <HTMLDivElement>document.getElementById('apartOpt');
        if (type === 0) {
            if (!element1.classList.contains('addOpt')) {
                element1.classList.add('addOpt');
                this.accommodationType = type;
                this.VillaSelected = true;
            } else {
                element1.classList.remove('addOpt');
                if (this.ApartmentSelected) {
                    this.accommodationType = 1;
                } else {
                    this.accommodationType = -1;
                }
                this.VillaSelected = false;
            }
        } else if (type === 1) {
            if (!element2.classList.contains('addOpt')) {
                element2.classList.add('addOpt');
                this.accommodationType = type;
                this.ApartmentSelected = true;
            } else {
                element2.classList.remove('addOpt');
                if (this.VillaSelected) {
                    this.accommodationType = 0;
                } else {
                    this.accommodationType = -1;
                }
                this.ApartmentSelected = false;
            }
        }
        const required = <HTMLElement>document.getElementById('required-accomtype');
        if (required.classList.contains('required-info') && type !== -1) {
            required.classList.remove('required-info');
        }
    }

    datepickertoggle() {
        this.datepicker.toggle();
    }

    // sets the new calendars
    setCalendars() {

        // set minimum date for search datepicker, start-end range etc....
        const today = new Date();
        const nextDay = today.getDate() + 1;
        this.day = today.getDate();
        this.month = today.getMonth() + 1;
        this.year = today.getFullYear();
        this.minDate = { year: this.year, month: this.month, day: this.day };
        this.startDateFrom = this.minDate;
        this.startDateTo = { year: this.year, month: this.month, day: nextDay };
        this.checkInStartValue = this.year + '-' + this.month + '-' + this.day;
        this.checkInEndValue = this.year + '-' + this.month + '-' + nextDay;

    }

    onDateSelection(date: NgbDate) {

        if (!this.datesTracked) {
            this.angulartics2.eventTrack.next({ action: 'DatesAdded' });
            this.datesTracked = true;
        }

        let parsed = '';

        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
            this.toDate = date;
            this.datepickertoggle();
        } else {
            this.toDate = null;
            this.fromDate = date;
        }

        if (this.fromDate !== null && this.toDate !== null) {
            const N1 = Math.floor(275 * this.fromDate.month / 9);
            const N2 = Math.floor((this.fromDate.month + 9) / 12);
            const N3 = (1 + Math.floor((this.fromDate.year - 4 * Math.floor(this.fromDate.year / 4) + 2) / 3));
            const fromN = N1 - (N2 * N3) + this.fromDate.day - 30;

            const N4 = Math.floor(275 * this.toDate.month / 9);
            const N5 = Math.floor((this.toDate.month + 9) / 12);
            const N6 = (1 + Math.floor((this.toDate.year - 4 * Math.floor(this.toDate.year / 4) + 2) / 3));
            const toN = N4 - (N5 * N6) + this.toDate.day - 30;

            if (this.fromDate) {
                // if fromDate is set: add the first date
                parsed += this.formatter.format(this.fromDate);
            }
            // here we update the input value with the new parsed value
            this.nights = toN - fromN;

            this.renderer
                .setProperty(this.myRangeInput.nativeElement, 'value',
                    this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day);

            this.checkInString = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
            this.checkOutString = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
            this.datesSelected = true;
            this.noDatesSelected = false;
            const elem = <HTMLElement>document.getElementById('required-when');
            if (elem.classList.contains('required-info')) {
                elem.classList.remove('required-info');
            }
        }



    }

    isDateDisabled(date) {
        const xx = { day: date.day, month: date.month, year: date.year };
        const dateObj = new Date();
        const ngbDateStruct = { day: dateObj.getDate(), month: dateObj.getMonth() + 1, year: dateObj.getFullYear() };
        let isDisabled = true;
        if (xx.year < ngbDateStruct.year) { isDisabled = false; }
        if (xx.year === ngbDateStruct.year) {
            if (xx.month < ngbDateStruct.month) { isDisabled = false; }
            if (xx.month === ngbDateStruct.month) {
                if (xx.day < ngbDateStruct.day) { isDisabled = false; }
            }
        }

        return !isDisabled;
    }

    isDatesEqual(date1, date2) {
        if (date1 && date2) {
            return (date1.year === date2.year && date1.month === date2.month && date1.day === date2.day) ? true : false;
        }
        return false;
    }

    isHovered(date: NgbDate) {
        return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
    }

    isInside(date: NgbDate) {
        return date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date);
    }

    getUserId() {
        const user = localStorage.getItem('user');
        return JSON.parse(user).id;
    }

    sendRequest(sendToAll: String) {

        if (environment.production) {
            const allowed = this.getRequestExpiryCookie('expiryCookie');
            if (allowed !== null && allowed === false) {
                alert('You recently sent a request. Please wait 10 minutes before sending one again!');
                return;
            }
        }

        this.requestButtonDisabled = true;

        this.spinner.show();

        if (this.personalRequestText !== null && !this.personalRequestTracked) {
            this.angulartics2.eventTrack.next({ action: 'PersonalRequestAdded' });
            this.personalRequestTracked = true;
        }

        const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
        const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

        this.requestForSearch = {
            fromdate: fromDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            todate: toDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            adults: this.roomModalAdults,
            children: this.roomModalChildren,
            hotelextras:  /*this.filterExtraFlatFacilities(this.searchEngineContainer.getFlatExperiences())*/ '',
            offset: 0,
            limit: 10,
            sendRequests: sendToAll,
            experiences: this.selectedExperiences.toString(),
            personalrequest: this.personalRequestText,
            rooms: parseInt(this.roomModalRooms, 10),
            origin: this.sharedContainer.userCountry,
            accomodationtype: this.accommodationType,
            requestexpires: 9,
        };
        if (this.selectedLocation !== null) {
            this.requestForSearch.region = this.selectedLocation.toString();
        }
        if (this.accommodationType !== -1) {
            this.requestForSearch.accomodationtype = this.accommodationType;
        }
        if (this.VillaSelected && this.ApartmentSelected) {
            this.requestForSearch.accomodationtype = 2;
            this.accommodationType = 2;
        }
        this.requestForSearch.dailybudget = this.value;

        if (!this.sharedContainer.isLoggedIn$) {
            this.spinner.hide();
            this.angulartics2.eventTrack.next({ action: 'LoginPageFromFlow' });
            this.router.navigate(['login-page'], {
                queryParams: {
                    intent: 'signup',
                    checkInDate: this.requestForSearch.fromdate,
                    checkOutDate: this.requestForSearch.todate,
                    adults: this.roomModalAdults,
                    children: this.roomModalChildren,
                    sendRequests: this.requestForSearch.sendRequests,
                    'experiences': this.selectedExperiences.toString(),
                    'requestexpires': 9,
                    'personalrequest': this.personalRequestText,
                    'region': this.selectedLocation,
                    'rooms': parseInt(this.roomModalRooms, 10),
                    accomtype: this.accommodationType,
                    dailybudget: this.value,
                    sortby: 'high_to_low'
                }
            });
            this.requestButtonDisabled = false;
        } else {
            this.angulartics2.eventTrack.next({ action: 'ResultsFromFlow' });
            if (!this.router.url.includes('/results')) {
                this.requestForSearch.userid = this.getUserId();
                this.searchService.sendRequests(this.requestForSearch).subscribe((requestId: any) => {
                    this.spinner.hide();
                    this.router.navigate(['results/'], {
                        queryParams: {
                            checkInDate: this.requestForSearch.fromdate,
                            checkOutDate: this.requestForSearch.todate,
                            adults: this.roomModalAdults,
                            children: this.roomModalChildren,
                            sendRequests: this.requestForSearch.sendRequests,
                            'experiences': this.selectedExperiences.toString(),
                            'requestexpires': 8,
                            'personalrequest': this.personalRequestText,
                            'rooms': parseInt(this.roomModalRooms, 10),
                            requestId: requestId,
                            'region': this.selectedLocation,
                            accomtype: this.accommodationType,
                            dailybudget: this.value,
                            sortby: 'high_to_low'
                        }
                    });
                    // Adwords Conversion
                    if (environment.production) {
                        this.angulartics2.eventTrack.next({
                            action: 'sendrequest',
                            properties: { category: 'req_conversion' }
                        });
                    }
                    this.setRequestExpiryCookie('expiryCookie', false, 600000);
                });
            } else {
                this.spinner.hide();
                this.router.navigate(['results/'], {
                    queryParams: {
                        checkInDate: this.requestForSearch.fromdate,
                        checkOutDate: this.requestForSearch.todate,
                        adults: this.roomModalAdults,
                        children: this.roomModalChildren,
                        sendRequests: this.requestForSearch.sendRequests
                    }, queryParamsHandling: 'merge'
                });
            }
        }
    }

    loginAndSendRequest(): void {

        const email = <HTMLInputElement>document.getElementById('email');

        this.spinner.show();

        const fromDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day + 1);
        const toDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day + 1);

        this.requestForSearch = {
            checkInDate: fromDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            checkOutDate: toDate.toISOString().substring(0, 10).replace(/-0/g, '-'),
            adults: this.roomModalAdults,
            children: this.roomModalChildren,
            hotelextras:  /*this.filterExtraFlatFacilities(this.searchEngineContainer.getFlatExperiences())*/ '',
            offset: 0,
            limit: 10,
            sendRequests: 'withrequest',
            experiences: this.selectedExperiences.toString(),
            personalrequest: this.personalRequestText,
            rooms: parseInt(this.roomModalRooms, 10),
            origin: this.sharedContainer.userCountry,
            requestexpires: 13,
        };
        if (this.accommodationType !== -1) {
            this.requestForSearch.accomodationtype = this.accommodationType;
        }
        if (this.VillaSelected && this.ApartmentSelected) {
            this.requestForSearch.accomodationtype = 2;
            this.accommodationType = 2;
        }
        if (this.chosenLocations.length > 0) {
            this.requestForSearch.locations = this.chosenLocations.toString();
            this.requestForSearch.region = this.chosenLocations.toString();
        }
        this.requestForSearch.dailybudget = this.value;

        if (!this.sharedContainer.isLoggedIn$) {
            if (email.value !== undefined && email.value.length > 5
                && email.value.indexOf('@') !== -1) {

                this.userSignup.email = email.value;
                this.userSignup.name = email.value;
                this.userSignup.surname = email.value;
                this.userSignup.passwd = 'vervendo';

                this.basicAuth.register(this.userSignup).subscribe(userInfo => {
                    this.basicAuth.login(this.userSignup['email'], this.userSignup['passwd'])
                        .subscribe(
                            userInfoSU => {
                                const loggedInUser: IUser = {
                                    email: userInfoSU['email'],
                                    id: userInfoSU['id'],
                                    name: userInfoSU['name'],
                                    surname: userInfoSU['surname'],
                                    username: userInfoSU['username']
                                };
                                this.isLoggedIn$ = true;
                                this.sharedContainer.isLoggedIn$ = true;
                                this.sharedContainer.userLoggedInSub.next(true);
                                this.userLoggedInSub.next(true);
                                this.userId = userInfoSU['id'];
                                this.sharedContainer.userId = userInfoSU['id'];
                                super.loginUser(loggedInUser);
                                this.angulartics2.eventTrack.next({ action: 'RequestAfterSignUp' });
                                // Adwords Conversion
                                if (environment.production) {
                                    gtag('event', 'conversion', {
                                        'send_to': 'AW-777154659/3V4qCMuw1MQCEOPgyfIC'
                                    });
                                }
                                this.requestForSearch.userid = this.userId;
                                this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
                                this.requestForSearch.todate = this.requestForSearch.checkOutDate;
                                this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
                                    this.router.navigate(['results/'], {
                                        queryParams: {
                                            checkInDate: this.requestForSearch.checkInDate,
                                            checkOutDate: this.requestForSearch.checkOutDate,
                                            adults: this.requestForSearch.adults,
                                            children: this.requestForSearch.children,
                                            sendRequests: this.requestForSearch.sendRequests,
                                            'experiences': this.requestForSearch.experiences,
                                            'personalrequest': this.requestForSearch.personalrequest,
                                            'rooms': parseInt(this.requestForSearch.rooms, 10),
                                            sortby: 'high_to_low',
                                            region: this.requestForSearch.region,
                                            origin: this.sharedContainer.userCountry,
                                            accomtype: this.accommodationType,
                                            dailybudget: this.value,
                                            requestId: requestId
                                        }
                                    });
                                    this.spinner.hide();
                                });
                            },
                            (error) => {
                                this.spinner.hide();
                                console.log(error.error);
                                alert(error.error);
                            }
                        );
                },
                    (error) => {
                        this.basicAuth.login(this.userSignup['email'], this.userSignup['passwd'])
                            .subscribe(
                                userInfoSU => {
                                    const loggedInUser: IUser = {
                                        email: userInfoSU['email'],
                                        id: userInfoSU['id'],
                                        name: userInfoSU['name'],
                                        surname: userInfoSU['surname'],
                                        username: userInfoSU['username']
                                    };
                                    this.isLoggedIn$ = true;
                                    this.sharedContainer.isLoggedIn$ = true;
                                    this.sharedContainer.userLoggedInSub.next(true);
                                    this.userLoggedInSub.next(true);
                                    this.userId = userInfoSU['id'];
                                    this.sharedContainer.userId = userInfoSU['id'];
                                    super.loginUser(loggedInUser);
                                    this.angulartics2.eventTrack.next({ action: 'RequestAfterSignUp' });
                                    this.requestForSearch.userid = this.userId;
                                    this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
                                    this.requestForSearch.todate = this.requestForSearch.checkOutDate;
                                    this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
                                        this.router.navigate(['results/'], {
                                            queryParams: {
                                                checkInDate: this.requestForSearch.checkInDate,
                                                checkOutDate: this.requestForSearch.checkOutDate,
                                                adults: this.requestForSearch.adults,
                                                children: this.requestForSearch.children,
                                                sendRequests: this.requestForSearch.sendRequests,
                                                'experiences': this.requestForSearch.experiences,
                                                'personalrequest': this.requestForSearch.personalrequest,
                                                'rooms': parseInt(this.requestForSearch.rooms, 10),
                                                sortby: 'high_to_low',
                                                region: this.requestForSearch.region,
                                                origin: this.sharedContainer.userCountry,
                                                accomtype: this.accommodationType,
                                                dailybudget: this.value,
                                                requestId: requestId
                                            }
                                        });
                                        this.spinner.hide();
                                    });
                                },
                                (error2) => {
                                    this.spinner.hide();
                                    console.log(error2.error);
                                    alert(error2.error);
                                }
                            );
                    });
            } else {
                this.spinner.hide();
                Swal.fire({
                    icon: 'error',
                    title: 'Please enter a valid email',
                });
            }

        } else {
            this.requestForSearch.userid = this.getUserId();
            this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
            this.requestForSearch.todate = this.requestForSearch.checkOutDate;
            this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
                this.router.navigate(['results/'], {
                    queryParams: {
                        checkInDate: this.requestForSearch.checkInDate,
                        checkOutDate: this.requestForSearch.checkOutDate,
                        adults: this.requestForSearch.adults,
                        children: this.requestForSearch.children,
                        sendRequests: this.requestForSearch.sendRequests,
                        'experiences': this.requestForSearch.experiences,
                        'personalrequest': this.requestForSearch.personalrequest,
                        'rooms': parseInt(this.requestForSearch.rooms, 10),
                        sortby: 'high_to_low',
                        region: this.requestForSearch.region,
                        origin: this.sharedContainer.userCountry,
                        accomtype: this.accommodationType,
                        dailybudget: this.value,
                        requestId: requestId
                    }
                });
                this.spinner.hide();
            });
        }

    }


    getRequestExpiryCookie(key) {
        const itemStr = localStorage.getItem(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }

    setRequestExpiryCookie(key, value, ttl) {

        const now = new Date();

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

}
